const MyData = {
  cover: {
    profileImg: "bhsite/images/profile.webp",
    backgroundImg:
      "data:image/jpeg;base64,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",
    name: "Bruno Varisco Haetinger",
    position: "Software Engineer",
    links: {
      linkedin: "https://www.linkedin.com/in/bruno-haetinger/",
      github: "https://github.com/brunohaetinger/",
      stackoverflow:
        "https://pt.stackoverflow.com/users/124207/bruno-v-haetinger?tab=profile",
    },
    cvDownloadURL: "",
  },
  about: {
    description: {
      text: `Bruno is a Software Engineer driven by learning and improving himself to be the best version possible of it.`,
      citation: `"I hear and I forget. I see and I remember. I do and I learn." - Confucius`,
    },
    dateOfBirth: "",
    residence: {
      country: "Brazil",
      state: "RS",
      city: "Porto Alegre",
    },
    services: [
      {
        iconClass: "fas fa-code",
        title: "Web Development",
        description:
          "Modern and mobile-ready website that will help you reach all of your marketing.",
      },
      {
        iconClass: "fas fa-mobile-alt",
        title: "Mobile Applications",
        description:
          "Mobile applications that will help you reach all of your customers.",
      },
    ],
    funFacts: [
      {
        iconClass: "fas fa-music",
        title: "Guitar player",
      },
      {
        iconClass: "fas fa-paw",
        title: "Dog lover",
      },
      {
        iconClass: "fas fa-coins",
        title: "Poker master (not)",
      },
      {
        iconClass: "fas fa-gamepad",
        title: "Fifa expert",
      },
    ],
    clients: [
      {
        img: "bhsite/porto-pao.png",
        title: "Porto Pão",
        url: "http://www.padariaportopao.com.br/",
      },
    ],
  },
  resume: {
    experience: [
      {
        period: "2012 - 2013",
        title: "PL/SQL Developer Intern",
        organization: "Dell",
        img:
          "https://media.licdn.com/dms/image/C560BAQFsjti3z3RG0A/company-logo_100_100/0?e=1542240000&v=beta&t=TwBwh2kffFxGdqgryAA3K-MNKgzk73JSRM2-WNzeAKw",
        description: `Main Activities: Assist in the development of projects using the Oracle E-Business Suite. Assist in programming PL / SQL and Java.`,
      },
      {
        period: "2014 - 2015",
        title: "Android Mobile Developer",
        organization: "SoftMóvel",
        img: "http://softmovel.com.br/assets/img/softmovel.png",
        description: `Main Activities: Develop and support the company's Android apps. Java /
				Android development.
				Projects: SivaPlus, SivaGeo, SivaDelivery, SivaTrade, etc.
				\n`,
      },
      {
        period: "2015 - 2016",
        title: "Mobile Developer",
        organization: "DBServer",
        img:
          "https://media.licdn.com/dms/image/C4E0BAQFEG7XvyxgnVw/company-logo_100_100/0?e=1542240000&v=beta&t=9bRfPGQs0Xv6uVKAtYoFma9n_eFSXYdl8rEdx9zma8w",
        description: `Main Activities: Develop and support of Android apps. Java / Android
				development. Develop hybrid mobile applications using Ionic framework and
				MEAN stack.
				\nProjects: Vivo Meu Negócio, Retool e DBVitae`,
      },
      {
        period: "2016 - 2017",
        title: "Mobile Developer",
        organization: "Resource IT Solutions",
        img:
          "https://media.licdn.com/dms/image/C4D0BAQEg9fFET8h3kw/company-logo_100_100/0?e=1542240000&v=beta&t=mT-B1TMAR5fkOj6JO3HyvH2F2Z4DAVNDArplOITEy5k",
        description: `Develop and support hybrid mobile apps, using Kony framework.
				\nProjects: Sicredi Mobi`,
      },
      {
        period: "2017 - 2018",
        title: "Senior Software Engineer",
        organization: "Sicredi",
        img:
          "https://media.licdn.com/dms/image/C560BAQEwhEkCtzNFxg/company-logo_100_100/0?e=1542240000&v=beta&t=F3Pj0G0dWSB4HFMTi9OskLCRqIP0ltY27O-nJzgjr8E",
        description: `Develop and support hybrid mobile apps, using Kony framework.
				\nProjects: Sicredi Mobi`,
      },
      {
        period: "2018 - 2020",
        title: "Lead Frontend Engineer",
        organization: "SAP",
        img:
          "https://media.licdn.com/dms/image/C4D0BAQEsTL5Xl-6FjQ/company-logo_100_100/0?e=1542240000&v=beta&t=ffBogg7oSzPB3naokcQevNMxwE9ZIxB4n7JMXvCDwIg",
        description: `Main activities: Lead the team, architecting solutions on the Front End and
				managing SCRUM processes. Also, develop PoC softwares using Big Data,
				Machine Learning, IoT. Focusing on frontend applications using React and
				Flutter, and, also, NodeJS in some backends.
				\nProjects: Discovery Standardization, Smart Recruiter, Demo Platform`,
      },
      {
        period: "2020 - 2021",
        title: "Lead Frontend Engineer",
        organization: "ilegra",
        img:
          "https://media.licdn.com/dms/image/C4D0BAQEsTL5Xl-6FjQ/company-logo_100_100/0?e=1542240000&v=beta&t=ffBogg7oSzPB3naokcQevNMxwE9ZIxB4n7JMXvCDwIg",
        description: `Main Activities: Develop Thomson Reuters brazilian accounting platform
				using Angular framework, with Jest for test automation. Also, lead the
				development of React Native apps.
				\nProjects: Thomson Reuters Accounting Platform & Orsegups app
				`,
      },
      {
        period: "2021 - present",
        title: "Lead Frontend Engineer",
        organization: "HappyFunCorp",
        img:
          "https://media.licdn.com/dms/image/C4D0BAQEsTL5Xl-6FjQ/company-logo_100_100/0?e=1542240000&v=beta&t=ffBogg7oSzPB3naokcQevNMxwE9ZIxB4n7JMXvCDwIg",
        description: `Main Activities: Lead Frontend projects development using React or NextJS frameworks, architecting the solution and managing the scope alignment with the stakeholders.
				`,
      },
    ],
    education: [
      {
        period: "2011 – 2014",
        title: "Computer Science",
        organization:
          "PUCRS - Pontifícia Universidade Católica do Rio Grande do Sul",
        description: "Bachelor's Degree in Computer Science as PUCRS.",
      },
      {
        period: "2017 – 2018",
        title: "MBA - Strategic Business Management",
        organization: "Unisinos - Universidade do Vale do Rio dos Sinos",
        description:
          "Master of Business Administration in Strategic Business Management at Unisinos.",
      },
    ],
    mySkills: [
      {
        skill: "Tech Knowledge",
        subItens: [
          {
            title: "React",
            percentage: 100,
          },
          {
            title: "NextJS",
            percentage: 100,
          },
          {
            title: "Angular",
            percentage: 100,
          },
          {
            title: "Ionic",
            percentage: 100,
          },
          {
            title: "Flutter",
            percentage: 100,
          },
          {
            title: "NodeJS",
            percentage: 100,
          },
          {
            title: "MongoDB",
            percentage: 100,
          },
          {
            title: "HTML - CSS - JavaScript",
            percentage: 100,
          },
          {
            title: "Git",
            percentage: 100,
          },
        ],
      },
      {
        skill: "Others",
        subItens: [
          {
            title: "SCRUM",
            percentage: 100,
          },
          {
            title: "Agile",
            percentage: 100,
          },
          {
            title: "Photoshop/Gimp",
            percentage: 100,
          },
        ],
      },
    ],
  },
  works: {
    mobileAndWeb: [
      {
        title: "Porto Pão App",
        img: "bhsite/images/works/portopaoapp.jpg",
        category: "Mobile",
        descriptionMD:
          "The project was an App used by Porto Pão customers to make their order though the smartphone. It was made using Ionic, NodeJS and MongoDB. One of the biggest challenge of the project was to integrate with a legacy ERP and connect directly to the ERP SQL database.",
        url:
          "https://play.google.com/store/apps/details?id=br.com.padariaportopao",
      },
      {
        title: "Vivo Meu Negócio",
        img: "bhsite/images/works/vivomeunegocio.jpg",
        category: "Mobile",
        descriptionMD:
          "This app was made to help people to build their business with wisdom and also submit some new business idea to compete against others ideas, hoping to be selected as the most innovative.",
        url: "",
      },
      {
        title: "SivaPlus",
        img: "bhsite/images/works/sivaplus.jpg",
        category: "Mobile",
        descriptionMD:
          "SivaPlus is main project from his 'family' of apps that is developed on Softmóvel. It's a pre-sale and Sale Solution ready to be delivered with the issuance of an Order, Invoice form or Electronic Invoice",
        url:
          "https://play.google.com/store/apps/details?id=br.com.softmovel.sivaplus",
      },
      {
        title: "Retool",
        img: "bhsite/images/works/retool.jpeg",
        category: "Mobile",
        descriptionMD:
          "Retool was a system developed to make the retail business easier. The system was composed from a backend maded with NodeJS with Express, a Ionic mobile app and MongoDB. The idea was to make the life of the business man simpler by delivering real-time selling data to the business owner.",
        url: "",
      },
      {
        title: "Sicredi App",
        img: "bhsite/images/works/sicredi.jpg",
        category: "Mobile",
        descriptionMD:
          "It's the mobile banking solution from the brazilian bank Sicredi. It was made using the hybrid mobile framework Kony.",
        url:
          "https://play.google.com/store/apps/details?id=br.com.sicredimobi.smart",
      },
    ],
    dataScience: [
      {
        title: "DunkyBot",
        img: "bhsite/images/works/dunkybot.jpg",
        category: "Betting Advisor",
        descriptionMD:
          "It was my project using artificial intelligence to predict if some soccer matches would finish tied and then advise me to bet on these.",
        url: "",
      },
      {
        title: "CheckScanner",
        img: "bhsite/images/works/checkscanner.jpeg",
        category: "Machine Learning",
        descriptionMD:
          "The CheckScanner is a solution to capture some information from brazilian banks checks using machine learning. My main goal is to improve my skills while I build some interesting project. It's under construction.",
        url: "",
      },
    ],
    others: [
      {
        title: "HavaBox",
        img: "bhsite/images/works/havabox.jpeg",
        category: "Investment Toolbox",
        descriptionMD:
          "The HavaBox was a Investment toolbox that I made to make the way people invest using bot even easier. With the bot you can apply your strategy using great part of the main indicator people uses in graphical analysis (such as MACD, RSI, HiLo, SAR, etc.). I developed it in MQL5, that is an language used in the trading softare MetaTrader 5",
        url: "",
      },
    ],
  },
  publications: [
    {
      title: "Sentiment Analysis on social network postings",
      date: "december, 2014",
      authors: "Bruno Varisco Haetinger, Pedro Webber and Sílvia W. M. Moraes",
    },
    {
      title:
        "Factors Limiting Innovation: the case of a cooperative financial institution",
      date: "june, 2018",
      authors: "Bruno Varisco Haetinger and Luciana Maines da Silva",
    },
  ],
  contact: {
    email: "brunohaetinger@gmail.com",
  },
}

export default MyData
